export const FBI_SET_INITIATE_INCIDENT_BLOCK_INCIDENT_TYPE_SUCCESS =
  'FBI_SET_INITIATE_INCIDENT_BLOCK_INCIDENT_TYPE_SUCCESS';
export const onInitiateIncidentBlockIncidentTypeChange = () => ({
  type: FBI_SET_INITIATE_INCIDENT_BLOCK_INCIDENT_TYPE_SUCCESS,
});
